import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'youtube-player',
  template: `
    <div *ngIf="videoId">
      <iframe [src]="safeUrl" [height]="height || 315" width="100%" frameborder="0" allowfullscreen></iframe>
    </div>
  `,
})
export class YoutubePlayerComponent {
  @Input() videoId: string;
  @Input() playerVars: any;
  @Input() height: number | string;

  safeUrl: SafeResourceUrl = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    if (this.videoId) {
      const params = this.playerVars
        ? Object.keys(this.playerVars)
            .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(this.playerVars[k])}`)
            .join('&')
        : '';
      const url = `https://www.youtube.com/embed/${this.videoId}${params ? '?' + params : ''}`;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }
}
